import React, { useState, useEffect } from "react";
import { FilterIcon } from "@heroicons/react/solid";

export default function TableHead({ columns, _handleFilter }) {
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 1024px)").matches
  );

  useEffect(() => {
    window
      .matchMedia("(min-width: 1024px)")
      .addEventListener("change", (e) => setMatches(e.matches));
  }, []);
  return (
    <div className="w-full grid grid-cols-8 justify-around divide-solid divide-green-800 bg-gray-200">
      {columns.map((column) => (
        <div className="flex relative bg-white w-full">
          <input
            className="border-0 focus:ring-0 pl-8 w-full h-full"
            autoComplete="off"
            placeholder={column.name}
            id={column.filter}
            disabled={column.filter ? false : true}
            type="text"
            onChange={(e) => {
              column.isFiltering = e.target.value == "" ? false : true;
              _handleFilter(e.target.value, column.filter);
            }}
          />
          {column.filter ? (
            <FilterIcon
              className={
                "w-6 h-full pointer-events-none absolute left-0 inset-y-0 " +
                (column.isFiltering ? "text-green-400" : "text-gray-400")
              }
            />
          ) : null}
        </div>
      ))}
    </div>
  );
}
